module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "align-self-stretch pb-5",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Dashboard")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: _vm.display.label
      }),
      expression: "{ html: display.label }",
      arg: "left"
    }],
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleDisplay($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "primary": _vm.display.icon === 'list'
    }
  }, [_vm._v("list")]), _vm._v(" "), _c('v-icon', [_vm._v("swap_horiz")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "primary": _vm.display.icon === 'grid_on'
    }
  }, [_vm._v("grid_on")])], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 wrap"
  }, [_c(_vm.component, {
    tag: "component",
    attrs: {
      "display": _vm.display,
      "type": _vm.type,
      "title": _vm.title
    }
  })], 1), _vm._v(" "), _c('v-bottom-nav', {
    staticClass: "primary",
    attrs: {
      "shift": "",
      "value": "true"
    }
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 1
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_c('span', [_vm._v("Utilizatori")]), _vm._v(" "), _c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 2
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 2
      }
    }
  }, [_c('span', [_vm._v("Clienti")]), _vm._v(" "), _c('v-icon', [_vm._v("business")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 3
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 3
      }
    }
  }, [_c('span', [_vm._v("Setari")]), _vm._v(" "), _c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 4
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 4
      }
    }
  }, [_c('span', [_vm._v("Flyers")]), _vm._v(" "), _c('v-icon', [_vm._v("insert_drive_file")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 5
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 5
      }
    }
  }, [_c('span', [_vm._v("Download")]), _vm._v(" "), _c('v-icon', [_vm._v("cloud_download")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 6
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab = 6
      }
    }
  }, [_c('span', [_vm._v("Dictionar")]), _vm._v(" "), _c('v-icon', [_vm._v("library_books")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a3468c5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Dashboard.vue
// module id = 177
// module chunks = 27